import { BuildEnvironment, builtEnvironment } from './builtEnvironment';

// Generic public-assets bucket, served directly from S3 (public read). Prod reuses the
// existing walp-public-assets bucket (also the origin of the brand-assets CloudFront
// distribution); every other environment (local/dev/demo/stage) shares the dev twin.
// Uploads are gated per feature by the server services that presign into a key prefix.
const isProd = builtEnvironment === BuildEnvironment.prod;

export const publicAssetsBucket = isProd ? 'walp-public-assets' : 'waterlily-public-assets-dev';
export const publicAssetsRegion = 'us-east-2';

export function publicAssetUrl(key: string): string {
  return `https://${publicAssetsBucket}.s3.${publicAssetsRegion}.amazonaws.com/${key}`;
}

// --- Advisor whitelabel logos ---

// No JPEG: it cannot have a transparent background, which makes logos render as an
// opaque box on the client header background.
export const ADVISOR_LOGO_EXTENSION_BY_CONTENT_TYPE = {
  'image/png': 'png',
  'image/svg+xml': 'svg',
} as const;
export type AdvisorLogoContentType = keyof typeof ADVISOR_LOGO_EXTENSION_BY_CONTENT_TYPE;

export const MAX_ADVISOR_LOGO_SIZE_BYTES = 2 * 1024 * 1024;

export function advisorLogoKeyPrefix(advisorId: string): string {
  return `advisor-logos/${advisorId}/`;
}
